export interface AcccountingRow {
  time: Date;
  account_id?: string;
  imsi_id: string;
  lat: number|null;
  lon: number|null;
  session_id: string;
  upload: string;
  download: string;
  upload_total: string;
  download_total: string;
  cisco_operator_account_id: number;
  network_id: number;
  customer_id: number|null;
  refdata_tac_id: number;
  apn_id: number;
  session_status_id: number;
  country_id: number;
  rat_id: number;
  termination_cause_id: any;
  is_lte_m: boolean;
  inserted_at: Date;
}